import { Paper, styled } from '@mui/material';

export const Wrapper = styled(Paper, { name: 'CalendarHeader' })(({ theme: { spacing } }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: spacing(2, 3),
  position: 'relative',
}));
